import {
  createClient,
  IdPathParameters,
  postDownloadRequestFactory,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { LogType } from './commands/get-log';

const client = createClient('/rest/operator-api/charging-stations');

export enum LogResponseStatus {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_CANCELED = 'ACCEPTED_CANCELED',
  REJECTED = 'REJECTED'
}

export enum LogUploadStatus {
  BAD_MESSAGE = 'BAD_MESSAGE',
  IDLE = 'IDLE',
  NOT_SUPPORTED_OPERATION = 'NOT_SUPPORTED_OPERATION',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  UPLOADED = 'UPLOADED',
  UPLOAD_FAILURE = 'UPLOAD_FAILURE',
  UPLOADING = 'UPLOADING',
  ACCEPTED_CANCELED = 'ACCEPTED_CANCELED'
}

export enum LogStorageLocation {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export interface LogRequest {
  id: string;
  createdAt: Date;
  type: LogType;
  responseReceivedAt?: Date;
  responseStatus?: LogResponseStatus;
  fileName?: string;
  errorCode?: string; // OCPP 2.x only
  uploadStatus?: LogUploadStatus;
  uploadStatusModifiedAt?: Date;
  storageLocation: LogStorageLocation;
}

export const chargingStationLogRequestsPermissions = {
  GET: 'cpms.get-charging-station-log-upload-statuses',
  DOWNLOAD: 'cpms.download-charging-station-log-file'
};

export const getChargingStationLogRequests: SearchOperation<
  LogRequest,
  IdPathParameters<string>
> = searchRequestFactory<LogRequest, IdPathParameters<string>>(client, {
  pattern: '/{id}/log-requests',
  permissionId: chargingStationLogRequestsPermissions.GET
});

export interface DownloadLogParams {
  chargingStationId: string;
  logRequestId: string;
}

export const downloadLog = postDownloadRequestFactory<DownloadLogParams>(client, {
  pattern: '/{chargingStationId}/log-requests/{logRequestId}/download',
  permissionId: chargingStationLogRequestsPermissions.DOWNLOAD
});
